import Process from './ProcessDS'

export default Process
